import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Searchbar } from 'app/components';
import MobileBanner from '../banner/mobileBanner';

import './style';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleEventSelect = (id, isResale) => {
    if (isResale) navigate(`/${id}`);
    else navigate(`/event/${id}`);
  };

  const handleBack = () => {
    console.log();
  };

  return (
    <div className="w-full flex justify-center items-center head h-[442px] mt-[100px]">
      <div className="headingContainer">
        <h2 className={`heading-m text-center`}>
          We bring you the <br />
          <span className="text-primary">hottest events</span> in town!
        </h2>

        {window.innerWidth < 650 ? (
          <Searchbar
            type="mobile"
            width="100%"
            height="80vh"
            onSelect={handleEventSelect}
            onClickBack={handleBack}
            universal = {true}
          />
        ) : (
          <Searchbar
            type="global"
            width="800px"
            height="65vh"
            onSelect={handleEventSelect}
            universal = {true}
          />
        )}
      </div>
    </div>
  );
};

export default HeroSection;
